import { NextPage } from "next";
import { useIntl } from "react-intl";
import { useState } from "react";
import { QuestionAndAnswer } from "@/components/common/questionAndAnswer/QuestionAndAnswer";
import { PageProps } from "@/pages/_app";
import Layout from "@/components/layout/Layout";
import { SEO } from "@/interfaces/seo";
import { SEOWithoutTemplate } from "@/interfaces/seoWithoutTemplate";
import {
  ContactBlock,
  ContactBlockProps,
} from "@/components/pages/faq/contactBlock/ContactBlock";
import { FAQMenu } from "@/components/pages/faq/faqMenu/FAQMenu";
import HeroBlock, {
  HeroBlockProps,
} from "@/components/common/heroBlock/HeroBlock";
import { StrapiEntity, StrapiImage } from "@/utils/strapi";
import { Section } from "@/components/common/section/Section";
import { BackButton } from "@/components/common/backButton/BackButton";

export type FAQQuestionsAndAnswersProps = {
  question: string;
  answer: string;
};

export type FAQTabsProps = {
  title: string;
  icon: StrapiEntity<StrapiImage>;
  questionsAndAnswers: FAQQuestionsAndAnswersProps[];
};

export type FAQPageContent = {
  heroBlock: HeroBlockProps;
  contact: ContactBlockProps | null;
  tabs: FAQTabsProps[];
  seo: SEO;
  seoWithoutTemplate: SEOWithoutTemplate;
};

type FAQPageProps = PageProps &
  FAQPageContent & {
    defaultCanonicalRoute: string;
  };

const homePath = "/";

export const FAQ: NextPage<FAQPageProps> = ({
  layout,
  heroBlock,
  seo,
  contact,
  tabs,
  seoWithoutTemplate,
  defaultCanonicalRoute,
}: FAQPageProps) => {
  const intl = useIntl();

  const [selectedTab, setSelectedTab] = useState<number>(0);

  return (
    <>
      <Layout
        layout={layout}
        defaultCanonicalRoute={defaultCanonicalRoute}
        pageMeta={seo}
        title={seoWithoutTemplate.title}
        description={seoWithoutTemplate.description}
        breadcrumbs={[
          { title: intl.formatMessage({ id: "home" }), url: "/" },
          {
            title: intl.formatMessage({ id: `faqBreadcrumb` }),
            url: defaultCanonicalRoute,
          },
        ]}
      >
        <HeroBlock {...heroBlock} hideSearchBlock={true} />
        <Section>
          <BackButton path={homePath}></BackButton>
        </Section>
        {contact != null && (
          <ContactBlock email={contact.email} phone={contact.phone} />
        )}
        <Section>
          <FAQMenu
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
            tabs={tabs}
          />
          {tabs.length > 0 &&
            tabs[selectedTab].questionsAndAnswers.map((qAndA, index) => (
              <QuestionAndAnswer
                {...qAndA}
                selectedTab={selectedTab}
                key={index}
              />
            ))}
        </Section>
      </Layout>
    </>
  );
};
